import LayoutPage from '@/view/layout/Layout'

export default [{
    path: '/electoral',
    component: LayoutPage,
    children: [{
        path: 'list/PropagandaElectoral',
        name: 'list-propaganda-electoral',
        component: () => import('@/view/electoralpropaganda/ListPropagandaElectoral'),
    }]
}]